import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Car } from '@phosphor-icons/react';

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="relative">
            <Car size={48} className="text-[#0ABAB5] animate-pulse" weight="duotone" />
          </div>
          <div className="w-8 h-1 bg-[#0ABAB5] rounded-full animate-pulse" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export function AdminRoute({ children }) {
  // Admin Panel = Owner only. Manager + Staff are NOT allowed.
  const { user, loading, isSuperAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Car size={48} className="text-[#0ABAB5] animate-pulse" weight="duotone" />
          <div className="w-8 h-1 bg-[#0ABAB5] rounded-full animate-pulse" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export function OwnerRoute({ children }) {
  const { user, loading, isSuperAdmin } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <Car size={48} className="text-[#0ABAB5] animate-pulse" weight="duotone" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!isSuperAdmin) return <Navigate to="/" replace />;
  return children;
}
